import { FormHelperText } from '@material-ui/core'
import Slider from '@material-ui/core/Slider'
import { Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import RangedInput from './RangedInput'

interface IProps {
  TextInput?: any
  clearable?: boolean
  disableFuture?: boolean
  disabled?: boolean
  error?: { max: boolean; min: boolean }
  formatValue?: (value: number, index?: number) => string
  helperText?: React.ReactNode
  locale?: string
  // Max value excluded
  max: number
  // Min value excluded
  min: number
  onChange: (range: number | [number, number]) => void
  unit?: string
  value: number | number[]
}

function SliderFilter(props: IProps) {
  const {
    value,
    onChange,
    max,
    min,
    disableFuture,
    clearable,
    error = { min: false, max: false },
    helperText,
    unit,
    disabled,
    locale,
    formatValue,
    TextInput,
  } = props
  const { t } = useTranslation()
  const [buffer, setBuffer] = useState<number | number[]>(value)

  useEffect(() => setBuffer(value), [value])

  let values = null

  if (typeof buffer !== 'number' && buffer[0] !== undefined && buffer[1] !== undefined) {
    values = (
      <Stack flexDirection="row" justifyContent="space-between">
        <span>{formatValue ? formatValue(buffer[0]) : buffer[0]}</span>
        <span>{formatValue ? formatValue(buffer[1]) : buffer[1]}</span>
      </Stack>
    )
  }

  return (
    <Stack flexDirection="column" flexGrow={1}>
      {values}
      <Slider
        max={typeof max === 'number' ? max : parseInt(max, 10)}
        min={typeof min === 'number' ? min : parseInt(min, 10)}
        getAriaValueText={formatValue}
        disabled={disabled}
        value={buffer}
        onChange={(_event: React.ChangeEvent<Record<string, unknown>>, d: number | number[]) => {
          setBuffer(d as number | [number, number])
        }}
        onChangeCommitted={(_event: React.ChangeEvent<Record<string, unknown>>, d: number | number[]) => {
          onChange(d as number | [number, number])
        }}
      />
      {TextInput}
      {typeof value !== 'number' && !TextInput && (
        <Stack flexDirection="row">
          <Stack flexDirection="row" gap={1}>
            <RangedInput
              disabled={disabled}
              label={t('From')}
              min={min}
              max={value[1]}
              value={value[0]}
              onChange={(d: number | undefined) => {
                if (d && d < value[1] && d > min) {
                  onChange([d, value[1]])
                } else {
                  onChange([min, value[1]])
                }
              }}
              disableFuture={disableFuture}
              clearable={clearable}
              error={error.min}
              locale={locale}
            />
            <p style={{ fontSize: '10px', color: 'grey', alignSelf: 'end' }}>{unit}</p>
          </Stack>
          <div style={{ width: '10%', display: 'inline-block' }} />
          <Stack flexDirection="row" gap={1}>
            <RangedInput
              disabled={disabled}
              label={t('To')}
              min={typeof value === 'number' ? min : value[0]}
              max={max + 1}
              value={typeof value === 'number' ? value : value[1]}
              onChange={(d: number | undefined) => {
                if (d && d > value[0] && d < max) {
                  onChange([value[0], d])
                } else {
                  onChange([value[0], max])
                }
              }}
              disableFuture={disableFuture}
              clearable={clearable}
              error={error.max}
              locale={locale}
            />
            <p style={{ fontSize: '10px', color: 'grey', alignSelf: 'end' }}>{unit}</p>
          </Stack>
        </Stack>
      )}
      <br />
      <div style={{ display: error.min || error.max ? 'block' : 'none' }}>
        <FormHelperText component="div" error={error.min || error.max}>
          {helperText}
        </FormHelperText>
      </div>
    </Stack>
  )
}

export default SliderFilter
